import React from "react";
import styles from "./ChatFileCard.module.css";
import { IRtmTemplateNew } from "../../../hooks/rtmTemplate/index.type";
import { IResource } from "../../../hooks/rtm_resource/index.type";
import { Link } from "react-router-dom";

interface ChatFileProps {
  location: "template" | "resource" | "attachment";
  type: "text" | "file";
  templateData?: IRtmTemplateNew;
  resourceData?: IResource;
  attachmentData?: {
    id: number;
    fileName: string;
    fileSize: string;
  };
  isSelected?: boolean;
  onSelect: (id: string | undefined) => void;
}

const ChatFile: React.FC<ChatFileProps> = ({
  location,
  type,
  templateData,
  resourceData,
  attachmentData,
  isSelected,
  onSelect
}) => {
  return (
    <div className={styles.chatFilesWrapper}>
      {/* Template UI */}
      {location === "template" && templateData && (
        <div className={styles.chatFilesCard}>
          <input
            type="checkbox"
            checked={isSelected}
            onChange={() => templateData && onSelect(templateData._id)}
            className={styles.chatFilesCheckbox}
          />
          <p className={styles.chatFilesText}>{templateData.name}</p>
        </div>
      )}

      {/* Resource UI */}
      {location === "resource" && resourceData && (
        <div className={styles.chatFilesCard}>
          <input
            type="checkbox"
            checked={isSelected}
            onChange={() => resourceData && onSelect(resourceData._id)}
            className={styles.chatFilesCheckbox}
          />
          <div className={styles.attachmentContainer}>
            <div className={styles.fileDetails}>
              <p className={styles.chatFilesFileName}>
                {resourceData.fileName || resourceData.resourceName}
              </p>
              <Link to={`${resourceData.fileUrl}`}>
                <p className={styles.resourceUrl}>
                  {resourceData.fileUrl || resourceData.fileUrl}
                </p>
              </Link>
            </div>
          </div>
        </div>
      )}

      {/* Attachment UI */}
      {location === "attachment" && attachmentData && (
        <div className={styles.chatFilesCard}>
          <input
            type="checkbox"
            checked={isSelected}
            onChange={() => attachmentData && onSelect(attachmentData.fileName)}
            className={styles.chatFilesCheckbox}
          />
          <div className={styles.attachmentContainer}>
            <div className={styles.fileDetails}>
              <p className={styles.chatFilesFileName}>{attachmentData.fileName}</p>
              <p className={styles.chatFilesFileDescription}>
                Size: {attachmentData.fileSize}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatFile;